import { useMemo } from "react";
import { IQualificationOnCrew } from "@vmosolutions/oc-interfaces";
import moment from "moment-timezone";
import { Chip, Grid, Typography } from "@mui/material";

const oneMonthAsMillis = moment.duration(1, "month").asMilliseconds();
const oneWeekAsMillis = moment.duration(1, "week").asMilliseconds();
interface ICrewMemberQualificationProps {
  qualifications: IQualificationOnCrew[];
}

interface IQualificationListItem {
  name: string;
  expireDate?: string;
  expireColor?: "error" | "warning" | "default" | "primary" | "secondary" | "info" | "success";
}

export const CrewMemberQualifications = (props: ICrewMemberQualificationProps): JSX.Element => {
  const { qualifications } = props;

  const styledQuals: IQualificationListItem[] = useMemo(() => {
    const now = moment();
    const unsorted = qualifications.map((qual: IQualificationOnCrew) => {
      let styledQual: IQualificationListItem;
      if (typeof qual.isQualified === "boolean" && qual.isQualified === false) {
        styledQual = {
          name: qual.name,
          expireDate: qual.expireDate ? moment(qual.expireDate).format("MMM-DD-YYYY") : "Not Qual'd",
          expireColor: "error",
        };
      } else {
        if (!qual.expireDate) {
          styledQual = {
            name: qual.name,
            expireDate: "",
            expireColor: "default",
          };
        } else {
          const expireDate = new Date(qual.expireDate);
          const expireColor =
            moment(expireDate).diff(now) <= oneWeekAsMillis
              ? "error"
              : moment(expireDate).diff(now) <= oneMonthAsMillis
                ? "warning"
                : "default";
          styledQual = {
            name: qual.name,
            expireDate: moment(qual.expireDate).format("MMM-DD-YYYY"),
            expireColor: expireColor,
          };
        }
      }
      return styledQual;
    });
    return unsorted.sort((a, b) => {
      const dateA = a.expireDate ? new Date(a.expireDate).getTime() : null;
      const dateB = b.expireDate ? new Date(b.expireDate).getTime() : null;
      if (dateA === dateB) {
        return a.name.localeCompare(b.name);
      } else if (dateA === null) {
        return 1;
      } else if (dateB === null) {
        return -1;
      } else {
        return dateA - dateB;
      }
    });
  }, [qualifications]);
  return (
    <Grid container spacing={0}>
      <Grid item xs={12}>
        {styledQuals.map((qual, index) => (
          <Grid
            container
            rowSpacing={1}
            key={index}
            sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
          >
            <Grid item xs sx={{ fontSize: "0.7em", minHeight: "30px", alignItems: "center", display: "flex" }}>
              {qual.name}
            </Grid>
            {qual.expireDate && (
              <Grid item xs={"auto"}>
                <Chip
                  label={qual.expireDate}
                  color={qual.expireColor}
                  size={"small"}
                  sx={(theme) => ({
                    fontSize: "0.65em",
                    width: "70px",
                    borderRadius: "4px",
                    height: "20px",
                    m: "1px",
                    ".MuiChip-label": { px: "5px", py: "1px", m: "1px", color: theme.palette.text.primary },
                  })}
                />
              </Grid>
            )}
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};
